import { useCallback, useRef } from 'react';

export default function useRefInit(initializer) {
  const ref = useRef();

  const get = useCallback(() => {
    if (!ref.current) {
      ref.current = initializer();
    }
    return ref.current;
  }, [initializer]);

  return get();
}
